// @vendor
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// @components
import { OKLoadingErrorMessage } from "commonsComponents/OKLoadingErrorMessage";
import Accordion from "components/accordion/accordion.jsx";
import OkNgoAutosuggest from "components/okNgoAutosuggest/okNgoAutosuggest";
import OKTooltip from "commonsComponents/OKTooltip";
import OkNgoModal from "components/okNgoModal/okNgoModal";

// @utilities
import { getUrlAPINGOs, getUrlAPINGODetail } from "utilities/getUrlAPI";
import { getCategoriesNgos } from "utilities/formatNgosList";
import { getSearchedNGOs } from "utilities/filterSearcher";
import { hasLowerCase, capitalize } from "utilities/utilities";

require("./okNgoSearcher.scss");

const {
    NO_MATCH_FOUND,
    PLACEHOLDER_NGO_SEARCH,
    LABEL_SEARCHER_INPUT,
    SELECTED_NGO,
    NGO_LIST,
    YOUR_NGO,
    TOOLTIP_TEXT1,
    TOOLTIP_TEXT2,
    E_MAIL,
    DEFAULT_TOKEN
} = require("constants/ngoSearcherConstants");
const { STAGING_HOST, SPAIN, CARD } = require("constants/index");

class OkNgoSearcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ngosList: [],
            ngoListCategorized: [],
            value: "",
            filteredCategoriesList: [],
            ngoDetail: null,
            getNgoError: false,
            getNgoFetching: true,
            getNgoDetailError: false,
            getNgoErrorMessage: "",
            selected: [],
            modal: {
                isOpen: false
            }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        const { selected } = this.state;
        const selectedParent = !this.props.selected ? null : this.props.selected;

        if(selectedParent !== null && selectedParent.length >= 0 && selected.length !== selectedParent.length) {
            this.setState({
                selected: selectedParent
            })
        }
    }

    buildHeadersFetch = (isContactCenter, version=undefined) => {
        const { interactionId, userToken } = this.props;

        let requestHeader = {};

        if (isContactCenter) {
            requestHeader = this.assignParamToHeader(requestHeader, { 'openBankAuthToken': userToken } );
            requestHeader = this.assignParamToHeader(requestHeader, { 'openBankInteractionId': interactionId });
            !!version &&  (requestHeader = this.assignParamToHeader(requestHeader, { 'version': version}));  
        } else {
            requestHeader = this.assignParamToHeader(requestHeader, { 'openBankAuthToken': userToken } );
            !!version &&  (requestHeader = this.assignParamToHeader(requestHeader, { 'version': version}));  
        }
        return requestHeader;
    }

    assignParamToHeader = (header, param) => {
        return Object.assign(header, param);
    }

    handleShowDetailNgo = (ngoId, e) => {
        e.stopPropagation();
        const { environmentConfig, country, isContactCenter } = this.props;
        const url = getUrlAPINGODetail(environmentConfig, country, ngoId, isContactCenter);
        const headersFetch = this.buildHeadersFetch(isContactCenter);

        if (url) {
            fetch(url, {
                method: "GET",
                headers: headersFetch
            })
            .then(response => response.json())
            .then(response => {
                const { ngosList, selected } = this.state;
                const error = response.status
                    ? response.status !== 200
                    : response.length <= 0;
                const ngo = ngosList.filter(
                    option => option.uniquename === ngoId
                );
                const isSelected = selected.includes(ngo[0].ngoId);
                this.setState({
                    modal: {
                        isOpen: true,
                        id: ngoId,
                        ngoDetail: !error ? response[0].body.value : "",
                        ngoLogo: ngo[0].imagelogo,
                        ngoName: hasLowerCase(ngo[0].name)
                            ? ngo[0].name
                            : capitalize(ngo[0].name, true),
                        ngo: ngo,
                        ngoSelected: isSelected
                    },
                    getNgoDetailError: error,
                    getNgoErrorMessage: "error"
                });
            });
        }
    };

    // API REQUEST TO GET NGOS LIST
    fetchData = () => {
        const { selected } = this.state;
        const { environmentConfig, country, FormattedText, isContactCenter, context} = this.props;
        const url = getUrlAPINGOs(environmentConfig, country, isContactCenter, context); // GET URL (DIFFERENT URL FOR ENVIOREMENT)
        const headersFetch = this.buildHeadersFetch(isContactCenter,2);

        if (url) {
            fetch(url, {
                method: "GET", //METHOD
                headers: headersFetch
            })
            .then(response => response.json())
            .then(response => {
                const error = response.status
                    ? response.status !== 200
                    : response.length <= 0;

                this.setState({
                    ngosList: response,
                    ngoListCategorized: getCategoriesNgos(
                        response,
                        this.handleShowDetailNgo,
                        environmentConfig,
                        selected ? selected : [],
                        FormattedText
                    ),
                    filteredCategoriesList: getCategoriesNgos(
                        response,
                        this.handleShowDetailNgo,
                        environmentConfig,
                        selected ? selected : [],
                        FormattedText
                    ),
                    getNgoError: error,
                    getNgoFetching: false,
                    getNgoErrorMessage: response.message
                });
            })
            .catch((error) => {
                this.setState({
                    ngosList: [],
                    getNgoError: true,
                    getNgoFetching: false,
                    getNgoErrorMessage: error
                });
            });
        }
    };

    onHandleSelected = item => {
        const { selected, ngosList } = this.state;
        const {
            onClickCallBack,
            environmentConfig,
            FormattedText,
            deleteLastOneOption
        } = this.props;

        let newSelectedArray = selected.length === 0 ? selected : [...selected];
        const indexSelectedId = selected.indexOf(item.ngoId);

        if (!deleteLastOneOption) {
            indexSelectedId < 0
                ? newSelectedArray.push(item.ngoId)
                : newSelectedArray.splice(indexSelectedId, 1);
        } else {
            newSelectedArray = [];
            indexSelectedId < 0
                ? newSelectedArray.push(item.ngoId)
                : newSelectedArray;
        }

        onClickCallBack(
            ngosList.filter(ngo => newSelectedArray.includes(ngo.ngoId))
        );

        this.setState({
            selected: newSelectedArray,
            filteredCategoriesList: getCategoriesNgos(
                ngosList,
                this.handleShowDetailNgo,
                environmentConfig,
                newSelectedArray,
                FormattedText
            )
        });
    };

    handleOnChange = e => {
        const {
            ngosList,
            ngoListCategorized,
            categoriesList,
            selected
        } = this.state;
        const { environmentConfig, FormattedText } = this.props;

        this.setState({
            value: e.currentTarget.value,
            filteredCategoriesList:
                e.target.value !== ""
                    ? getSearchedNGOs(
                          e,
                          categoriesList,
                          ngosList,
                          this.handleShowDetailNgo,
                          environmentConfig,
                          selected,
                          FormattedText
                      )
                    : ngoListCategorized
        });
    };

    handleClose = ngo => {
        this.setState(
            {
                modal: {
                    isOpen: false
                }
            },
            () => {
                ngo && this.onHandleSelected(ngo[0]);
            }
        );
    };

    buildTooltipContent = () => {
        const { FormattedText } = this.props;

        return (
            <Fragment>
                <p className="tooltip__text">
                    <FormattedText value={"ngosSelector-tooltipText1"} />
                </p>
                <p className="tooltip__text">
                    <FormattedText value={"ngosSelector-tooltipText2"} />
                    <span className="tooltip__mail">
                        <FormattedText value={"ngosSelector-eMail"} />
                    </span>
                </p>
            </Fragment>
        );
    };

    buildNgoContent = () => {
        const {
            getNgoError,
            getNgoFetching,
            getNgoErrorMessage,
            selected,
            filteredCategoriesList,
            ngosList,
            value,
            modal: { isOpen, ngoDetail, ngoName, ngoLogo, ngo, ngoSelected }
        } = this.state;
        const {
            maxSelection,
            sigleOpenTab,
            environmentConfig,
            itemCompareSelected,
            FormattedText,
            formatText,
            allTabsClosed,
            deleteLastOneOption
        } = this.props;

        const tooltipContent = this.buildTooltipContent();
        const ngoListText = <FormattedText value={"ngosSelector-ngoList"} />;
        const yourNgoText = <FormattedText value={"ngosSelector-yourNGO"} />;
        const placeHolder = formatText("ngosSelector-placeholderNGOSearch");
        const textLabelOneOrMoreNGOSelect = this.getTextForOneOrMoreNGOLabel(FormattedText, maxSelection);

        return (
            <OKLoadingErrorMessage
                isLoading={getNgoFetching}
                isError={getNgoError}
                primaryTextError={getNgoErrorMessage}
            >
                <OkNgoAutosuggest
                    value={value}
                    handleSelectedInAutosuggest={this.onHandleSelected}
                    placeholderNgo={placeHolder}
                    filteredCategoriesList={ngosList}
                    noNgoFoundMessage={
                        <FormattedText value={"ngosSelector-noMatchFound"} />
                    }
                    labelSearcherInput={textLabelOneOrMoreNGOSelect}
                />
                <p className="regular__text">
                    {yourNgoText}{" "}
                    <OKTooltip placement="top" content={tooltipContent} />
                </p>
                <p className="title">{ngoListText}</p>
                <Accordion
                    allTabsClosed={allTabsClosed}
                    content={filteredCategoriesList}
                    selected={selected}
                    maxSelection={maxSelection}
                    sigleOpenTab={sigleOpenTab}
                    handleSelected={this.onHandleSelected}
                    itemCompareSelected={itemCompareSelected}
                    FormattedText={FormattedText}
                    deleteLastOneOption={deleteLastOneOption}
                />
                <OkNgoModal
                    isOpen={isOpen}
                    ngoDetail={ngoDetail}
                    ngoName={ngoName}
                    ngoLogo={ngoLogo}
                    ngo={ngo}
                    FormattedText={FormattedText}
                    onHandleClose={this.handleClose}
                    environmentConfig={environmentConfig}
                    ngoSelected={ngoSelected}
                    maxSelected={maxSelection === selected.length}
                    deleteLastOneOption={deleteLastOneOption}
                />
            </OKLoadingErrorMessage>
        );
    };

    getTextForOneOrMoreNGOLabel = (FormattedText, max) => {
        const MAX_SELECTION_FOR_TITLE_FOR_NEW_TRANSFER_NGO = 1;
        return <FormattedText value={max === MAX_SELECTION_FOR_TITLE_FOR_NEW_TRANSFER_NGO? "ngoModal-title":"ngosSelector-labelSearcherInput"}/>
    };

    render() {
        if (this.state.ngosList.length >= 0) {
            return this.buildNgoContent();
        } else {
            return null;
        }
    }
}

OkNgoSearcher.propTypes = {
    environmentConfig: PropTypes.string,
    country: PropTypes.string,
    context: PropTypes.string,
    selected: PropTypes.array,
    maxSelection: PropTypes.number,
    sigleOpenTab: PropTypes.bool,
    noNgoFoundMessage: PropTypes.string,
    placeholderNgo: PropTypes.string,
    selectedNgo: PropTypes.string,
    ngoList: PropTypes.string,
    yourNgo: PropTypes.string,
    userToken: PropTypes.string,
    labelSearcherInput: PropTypes.string,
    tooltipText1: PropTypes.string,
    tooltipText2: PropTypes.string,
    eMail: PropTypes.string,
    onClickCallBack: PropTypes.func,
    itemCompareSelected: PropTypes.string,
    FormattedText: PropTypes.func,
    isContactCenter: PropTypes.bool,
    formatText: PropTypes.func,
    interactionId: PropTypes.string,
    allTabsClosed: PropTypes.bool,
    deleteLastOneOption: PropTypes.bool,
};

OkNgoSearcher.defaultProps = {
    environmentConfig: STAGING_HOST,
    country: SPAIN,
    selected: null,
    maxSelection: 5,
    sigleOpenTab: true,
    allTabsClosed: true,
    noNgoFoundMessage: NO_MATCH_FOUND,
    placeholderNgo: PLACEHOLDER_NGO_SEARCH,
    labelSearcherInput: LABEL_SEARCHER_INPUT,
    yourNgo: YOUR_NGO,
    selectedNgo: SELECTED_NGO,
    ngoList: NGO_LIST,
    tooltipText1: TOOLTIP_TEXT1,
    tooltipText2: TOOLTIP_TEXT2,
    eMail: E_MAIL,
    itemCompareSelected: "ngoId",
    onClickCallBack: () => null,
    FormattedText: () => {throw "FormattedText not defined"},
    formatText: () => {throw "formatText not defined"},
    isContactCenter: false,
    interactionId: null,
    userToken: DEFAULT_TOKEN,
    deleteLastOneOption: false,
    context: CARD
};

export default OkNgoSearcher;
